import { ThunkDispatch } from "redux-thunk";
import { TApiParameter } from "../../api/endpoints/Parameter";
import * as Api from "../../api";

export const PARAMETERS_FETCH_COMPLETED = 'PARAMETERS_FETCH_COMPLETED';

export interface IFetchParametersCompletedAction {
  type: typeof PARAMETERS_FETCH_COMPLETED,
  data: Array<TApiParameter>
}

const fetchParametersCompleted = (parameters: Array<TApiParameter>): IFetchParametersCompletedAction => ({
  type: PARAMETERS_FETCH_COMPLETED,
  data: parameters
});


const fetchParameters = () => {
  return async (dispatch: ThunkDispatch<{}, {}, IFetchParametersCompletedAction>): Promise<Array<TApiParameter>> => {
    try {
      const parameters = await Api.Parameter.list();

      dispatch(fetchParametersCompleted(parameters))

      return parameters;
    } catch (error) {
      throw error;
    }
  }
}

export {
  fetchParameters
};
